import { useNavigate } from 'react-router-dom';
import { t } from 'i18next';
import HomeBottomNav from '../../layout/HomeBottomNav';
import NotificationBadge from '../my-page/components/NotificationBadge';
import SceneLogo from './components/SceneLogo';
import Bubble from '../components/floating/Bubble';
import { ROUTES } from '../../constants/routes';

const FIRST_TAG_DATA = [
  { id: 1, content: t('SceneIntro.tags.hate'), type: 'text', bgColor: 'bg-[#000000B2]' },
  {
    id: 2,
    content: t('SceneIntro.tags.colleague'),
    type: 'text',
    bgColor: 'bg-[#0000004D]'
  },
  { id: 3, content: 'hand_heart', type: 'icon' },
  { id: 4, content: 'scene_sample_profile1', type: 'image' },
  {
    id: 5,
    content: t('SceneIntro.tags.inLove'),
    type: 'text',
    bgColor: 'bg-[#00000080]'
  },
  {
    id: 6,
    content: t('SceneIntro.tags.unexpectedMeeting'),
    type: 'text',
    bgColor: 'bg-[#0000004D]'
  },
  { id: 7, content: t('SceneIntro.tags.excited'), type: 'text', bgColor: 'bg-[#000000B2]' },
  { id: 8, content: t('SceneIntro.tags.waiting'), type: 'text', bgColor: 'bg-[#0000004D]' }
];

const SECOND_TAG_DATA = [
  {
    id: 1,
    content: t('SceneIntro.tags.misunderstanding'),
    type: 'text',
    bgColor: 'bg-[#00000066]'
  },
  {
    id: 2,
    content: 'handshake',
    type: 'icon'
  },
  { id: 3, content: t('SceneIntro.tags.onAir'), type: 'text', bgColor: 'bg-[#000000B2]' },
  { id: 4, content: t('SceneIntro.tags.tense'), type: 'text', bgColor: 'bg-[#00000080]' },
  { id: 5, content: 'scene_sample_profile2', type: 'image' },
  { id: 6, content: 'scene_sample_profile3', type: 'image' },
  { id: 7, content: 'shoulder_hug', type: 'icon' },
  { id: 8, content: t('SceneIntro.tags.friend'), type: 'text', bgColor: 'bg-[#000000B2]' }
];

const SceneIntroPage = () => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen relative overflow-hidden pt-[calc(env(safe-area-inset-top))] pb-[calc(120px+env(safe-area-inset-bottom))] bg-[linear-gradient(180deg,#000_0%,#2D2E59_93.41%)]">
      <header className="flex items-center justify-between px-[24px] w-full z-10">
        <h1 className="text-[26px] font-bold leading-[31px] text-separator-light-2 py-[11px]">
          {t('SceneIntro.title')}
        </h1>
        <NotificationBadge className="bg-secondary-dark rounded-full" />
      </header>
      <div
        className="fixed inset-0 mx-[58px] bg-center bg-no-repeat bg-contain flex flex-col items-center"
        style={{
          backgroundImage: 'url(/assets/scene/bg_scene_intro.png)'
        }}
      >
        <SceneLogo className="pt-[calc(123px+env(safe-area-inset-top))]" />
        <div className="mt-[46px] flex flex-col items-center gap-[14px]">
          <p className="text-[20px] font-semibold leading-[24px] text-pure-white text-center whitespace-pre-line">
            {t('SceneIntro.introTitle')}
          </p>
          <p className="text-[15px] font-medium leading-[18px] text-main-light-4">
            {t('SceneIntro.introDescription')}
          </p>
        </div>
        <div className="mt-[70px] w-screen">
          <div className="relative w-full h-[131px]">
            <div
              className="absolute inset-0 bg-[rgba(255,255,255,0.10)] w-full h-[131px] z-0"
              style={{
                filter: 'blur(12.8px)',
                backdropFilter: 'blur(12px)',
                WebkitBackdropFilter: 'blur(12px)',
                maskImage:
                  'linear-gradient(to bottom, transparent 0%, black 20%, black 80%, transparent 100%)',
                WebkitMaskImage:
                  'linear-gradient(to bottom, transparent 0%, black 20%, black 80%, transparent 100%)'
              }}
            />
            <div className="relative z-10 h-full overflow-hidden">
              <div className="flex flex-col h-full justify-center gap-[10px]">
                <div className="scene-marquee flex w-max items-center gap-[10px]">
                  {FIRST_TAG_DATA.map((tag) => (
                    <Tag key={`first-1-${tag.id}`} tag={tag} />
                  ))}
                  {FIRST_TAG_DATA.map((tag) => (
                    <Tag key={`first-2-${tag.id}`} tag={tag} />
                  ))}
                </div>
                <div className="scene-marquee-reverse flex w-max items-center gap-[10px]">
                  {SECOND_TAG_DATA.map((tag) => (
                    <Tag key={`second-1-${tag.id}`} tag={tag} />
                  ))}
                  {SECOND_TAG_DATA.map((tag) => (
                    <Tag key={`second-2-${tag.id}`} tag={tag} />
                  ))}
                </div>
              </div>
            </div>
          </div>
          <div className="flex flex-col items-center gap-[13px] mt-[34px]">
            <Bubble text={t('SceneIntro.freeCombination')} gradientDirection="center" />
            <button
              type="button"
              className="bg-[linear-gradient(136deg,#15CCCB_1.21%,#4987FF_50.69%,#8B1CFA_101.7%)] min-w-[192px] rounded-full py-[16px] text-[17px] font-semibold leading-[20px] text-pure-white shadow-[0_0_3px_0_rgba(0,0,0,0.05),_0_0_8px_0_rgba(0,0,0,0.10)]"
              onClick={() => navigate(ROUTES.SCENE.SETTING)}
            >
              {t('SceneIntro.startButton')}
            </button>
          </div>
        </div>
      </div>
      {/* biome-ignore lint/a11y/noPositiveTabindex: HomeBottomNav 내부에서 탭 선택용 커스텀 prop으로 사용 */}
      <HomeBottomNav tabIndex={2} />
    </div>
  );
};

export default SceneIntroPage;

const Tag = ({ tag }: { tag: (typeof FIRST_TAG_DATA)[0] }) => {
  if (tag.type === 'image') {
    return (
      <img
        src={`/assets/scene/${tag.content}.png`}
        alt={tag.content}
        className="w-[48px] h-[48px] rounded-full shrink-0"
      />
    );
  }

  if (tag.type === 'icon') {
    return (
      <div className="w-[48px] h-[48px] shrink-0 rounded-[12px] bg-[rgba(0,0,0,0.15)] flex items-center justify-center">
        <img
          src={`/assets/scene/${tag.content}.png`}
          alt={tag.content}
          className="w-[24px] h-[24px] object-contain"
        />
      </div>
    );
  }

  return (
    <div
      className={`w-fit px-[13px] py-[15px] rounded-[10px] whitespace-nowrap shrink-0 ${tag.bgColor}`}
    >
      <p className="text-[15px] font-semibold leading-[18px] text-pure-white">{tag.content}</p>
    </div>
  );
};
